'use client';
import Image from 'next/image';
import { cn } from '@/app/utils/cn';
import checkTruthyValue from '@/app/utils/checkTruthyValue';

function LogoItem({ brand, className }) {
    if (!brand?.logo?.idPath) return null;
    return (
        <div className="relative flex shrink-0 items-center justify-center">
            <div className="relative h-14 w-[140px]">
                <Image
                    src={brand.logo.idPath}
                    fill
                    sizes="140px"
                    quality={25}
                    className={cn('object-contain transition-all duration-200', className)}
                    alt={`${brand.title} logo`}
                />
            </div>
        </div>
    );
}

function Brands(props) {
    const { widgetTitle, logos, identifier } = props;
    const isDark = checkTruthyValue(props.isDark);

    const logoClassName = isDark
        ? 'opacity-40 brightness-0 invert hover:opacity-90'
        : 'grayscale hover:grayscale-0';

    // Duplicate logos so the second set starts exactly where the first ends,
    // allowing the -50% translateX to loop seamlessly.
    const track = logos ? [...logos, ...logos] : [];

    return (
        <div className={cn('relative overflow-visible px-4 py-16', !isDark && 'bg-white')}>
            <div
                className={cn(
                    'absolute inset-0',
                    isDark
                        ? 'bg-[radial-gradient(ellipse_at_center,hsl(var(--highlight)/0.25),transparent_70%)]'
                        : 'bg-[radial-gradient(ellipse_at_center,hsl(var(--highlight)/0.01),transparent_60%)]'
                )}
            />
            <div className="relative z-10">
                {widgetTitle && (
                    <div className="mb-10 text-center">
                        <span
                            className={cn(
                                'text-[13px] font-semibold uppercase tracking-widest',
                                isDark ? 'text-primary-foreground/80' : 'text-gray-400'
                            )}>
                            {widgetTitle}
                        </span>
                    </div>
                )}
                <div className="fade-edges overflow-hidden">
                    <div className="flex w-max animate-marquee items-center gap-10 hover:[animation-play-state:paused]">
                        {track.map((brand, i) => (
                            <LogoItem
                                key={(identifier ?? '') + i}
                                brand={brand}
                                className={logoClassName}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Brands;
